import { registryComponent } from '@boost-sd/components-registry/registry';
import { Trans, useTranslation } from '@hooks/useTranslation';
import { createClsNameMap, mergeModifiers } from '@utils/classnames';

export const clsNameMap = createClsNameMap({
  elements: {
    container: createClsNameMap(),
    link: createClsNameMap(),
    pagination: createClsNameMap(),
  },
  modifiers: [
    'top-left',
    'top-center',
    'top-right',
    'middle-left',
    'middle-center',
    'middle-right',
    'bottom-left',
    'bottom-center',
    'bottom-right',
    'on-top',
  ],
})('breadcrumb');

export type BreadcrumbProps = {
  enablePagination?: boolean;
  enableCollectionList?: boolean;
  enableCollectionTitle?: boolean;
  alignment?:
    | 'top-left'
    | 'top-center'
    | 'top-right'
    | 'middle-left'
    | 'middle-center'
    | 'middle-right'
    | 'bottom-left'
    | 'bottom-center'
    | 'bottom-right';
  placement?: 'on-top' | 'above-title';
  totalPages?: number;
  page?: number;
  title?: string;
  link?: string;
};

const Breadcrumb = ({
  enablePagination,
  enableCollectionList,
  enableCollectionTitle,
  alignment = 'middle-center',
  placement = 'on-top',
  link,
  totalPages,
  page,
  title,
}: BreadcrumbProps) => {
  const { t } = useTranslation();

  return (
    <nav
      className={mergeModifiers(clsNameMap, [
        [alignment],
        {
          'on-top': placement === 'on-top',
        },
      ])}
    >
      <div className={clsNameMap.elm('container')}>
        <a href='/' className={clsNameMap.elm('link')} title={t('breadcrumb.toFrontPage')}>
          {t('breadcrumb.home')}
        </a>

        {enableCollectionList && (
          <a href={link} className={clsNameMap.elm('link')}>
            {t('breadcrumb.collections')}
          </a>
        )}

        {enableCollectionTitle && <div className={clsNameMap.elm('link')}>{title}</div>}

        {enablePagination && totalPages !== null && page !== null ? (
          <div className={clsNameMap.elm('link')}>
            <Trans i18nKey={'breadcrumb.pagination'} values={{ page, totalPages }} />
          </div>
        ) : (
          <></>
        )}
      </div>
    </nav>
  );
};

export default registryComponent('Breadcrumb', Breadcrumb);
